export default {
  getTypes: '/courier/api/trade/types',
  getTransactionsData: '/courier/api/v2/my/transactions',
  queryCourierServiceFee: '/gateway'
}
